<script setup lang="ts">
import {reactive, ref} from "vue";
import MultiImageUploader from "components/common/MultiImageUploader.vue";

const multiImageUploader = ref<InstanceType<typeof MultiImageUploader>>()
const visible = ref(false)

const initData = {
  content: "",
}

const form = reactive({...initData})

const show = () => {
  visible.value = true
}

const hide = () => {
  visible.value = false
}

const onClose = () => {
  Object.assign(form, initData)
}

const emit = defineEmits(["submit"])

const onSubmit = () => {
  emit("submit", {
    content: form.content,
    image: multiImageUploader.value?.getImageUrls() || "",
  })
}

defineExpose({show, hide})
</script>

<template>
  <el-dialog title="提交留言" v-model="visible" align-center @close="onClose">
    <el-input class="my-border mt-2rem" type="textarea" v-model="form.content" placeholder="请输入反馈内容"
              show-word-limit maxlength="500" :autosize="{ minRows: 6, maxRows: 10 }"/>
    <div class="mt-2rem">
      <multi-image-uploader :max="3" ref="multiImageUploader"/>
    </div>
    <div class="mt-4rem">
      <el-button type="primary" @click="onSubmit">
        提交
      </el-button>
      <el-button type="primary" plain @click="hide">取消</el-button>
    </div>
  </el-dialog>
</template>

<style scoped>
</style>
